import React from 'react';
import { Menu, MenuProps, theme } from 'antd';
import styles from './styles.module.scss';
import { useLocation } from 'react-router-dom';

const componentId = 'layout/page/navigation/desktop';

type MenuItem = Required<MenuProps>['items'][number];

type Props = {
  navItems: MenuItem[];
  onClickMenuItem?: () => void;
};

const defaultProps: Props = {
  navItems: [],
};

function DesktopNavigation(props: Props) {
  const selectedKey = useLocation().pathname;
  const {
    token: { colorBgContainer, borderRadiusOuter },
  } = theme.useToken();

  const highlight = () => {
    if (selectedKey === '/') {
      return ['home'];
    } else if (selectedKey === '/support') {
      return ['support'];
    } else {
      return null;
    }
  };

  return (
    <Menu
      theme="dark"
      mode="vertical"
      items={props.navItems}
      style={{ background: '#120338', borderRadius: borderRadiusOuter }}
      className={styles.menu}
      selectedKeys={highlight()}
      defaultSelectedKeys={['home']}
      onClick={props.onClickMenuItem}
    />
  );
}

DesktopNavigation.defaultProps = defaultProps;
export default React.memo(DesktopNavigation);
